import React from 'react'
import { Button, Card, CardContent } from '@bpinternal/ui-kit-next'
import { AlertTriangle, ExternalLink } from 'lucide-react'
import { getCdmStudioUrl } from '~/shared/configurations'

interface PreventKbUseProps {
  kbs: Array<{ id: string; name: string }>
  open: boolean
  botId: string
}

export const PreventKbUse: React.FC<PreventKbUseProps> = ({ kbs, open, botId }) => {
  if (kbs.length === 0 || !open) {
    return null
  }

  return (
    <div className="flex justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-6 rounded-lg border bg-card p-6 shadow-lg">
        <div className="space-y-2">
          <h2 className="text-lg font-semibold leading-none tracking-tight text-foreground">
            Legacy knowledge base detected
          </h2>
          <p className="text-sm text-muted-foreground">
            You have {kbs.length} legacy knowledge base{kbs.length > 1 ? 's' : ''} that need
            {kbs.length === 1 ? 's' : ''} to be migrated before you can access this page.
          </p>
        </div>

        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">The following legacy knowledge bases need to be migrated:</p>
          <ul className="space-y-2">
            {kbs.map((kb) => (
              <li key={kb.id} className="rounded bg-muted p-2 text-sm">
                {kb.name}
              </li>
            ))}
          </ul>
        </div>

        <Card className="border-amber-200 bg-amber-50">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-700" />
              <div className="space-y-2">
                <p className="text-sm font-medium text-amber-700">Manual publish required</p>
                <p className="text-sm text-amber-700">
                  Open the studio and publish your bot to migrate your knowledge bases.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="flex flex-col justify-end gap-2 sm:flex-row">
          <a
            href={getCdmStudioUrl(botId)}
            className="inline-flex items-center gap-1 text-sm text-brand-700 underline hover:text-brand-600"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Studio to Migrate
            <ExternalLink className="h-3 w-3" />
          </a>
        </div>
      </div>
    </div>
  )
}
